require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./hear-from-our-partners.json") })
        }
      }, "path---hear-from-our-partners");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---hear-from-our-partners!./.cache/json/hear-from-our-partners.json
// module id = 1164
// module chunks = 231608221292675